import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a51918d2cc2500014fccc56_1787006702528_749411c4/lazosleis/src/app/login-screen/components/LoginPageContent.tsx");
